angular.module('articles_factories').factory('DraftArticlesFactory', ['$resource', function ($resource) {
    return $resource('/api/v2.0/articles/draftlist/');
}]);